function SeRutQuiz(el) {
    this.el = el;
    this.parentSection = this.el.parentElement;
    this.quizId = this.el.dataset.quizId;
    this.questions = JSON.parse(this.el.dataset.questions);
    this.summarySentences = JSON.parse(this.el.dataset.summarySentences);
    this.hadInteraction = false;
    this.activeScreen = 'start';
    this.backBtnEl = this.parentSection.querySelector('.jsBackBtn');
    this.replaceStringEls = this.el.querySelectorAll('.jsReplaceVariables');
    this.backBtnEventListeners = [];
    this.sourceEl = this.parentSection.querySelector('.jsTestSource');

    this.screens = {
        start: this.el.querySelector('.jsScreenStart'),
        questions: this.el.querySelector('.jsScreenQuestions'),
        singleResult: this.el.querySelector('.jsScreenSingleResult')
    };

    this.inputP1NameEl = this.el.querySelector('input[name="input-p1"]');
    this.urlData = { name: null };

    // Get the question elements
    this.currentQuestionIndex = 0;
    this.questionEls = this.screens.questions.querySelectorAll('.jsQuestion');
    this.questionCount = this.questionEls.length;

    for (let i = 0; i < this.questionCount; i++) {
        this.urlData['a' + (i + 1)] = null;
    }

    // Init the test
    this.init();

    this.backBtnEl.addEventListener('click', e => {
        e.preventDefault();

        // Call the event listeners
        this.backBtnEventListeners.forEach(listener => listener());

        // Do screen based navigation
        switch (this.activeScreen) {
            case 'singleResult' :
                this.goToScreen('questions');
            break;
        }
    });

    // Add a transition to anchor links
    document.body.addEventListener('click', e => {
        if (e.target.classList.contains('jsAnchorBtn')) {
            e.preventDefault();

            const el = document.getElementById(e.target.href.split('#')[1]);
            const bounds = el.getBoundingClientRect();

            vanillaSmoothie.scrollTo(bounds.top + window.scrollY - this.getResponsiveTopOffset(), { easing: 'easeInOutQuad' });
        }
    });
};

SeRutQuiz.prototype.init = function() {
    this.hideSource();
    this.initStartScreen();
    this.initSingleResultScreen();
    this.initActiveScreen();
}

SeRutQuiz.prototype.addBackBtnEventListener = function(listener) {
    this.backBtnEventListeners.push(listener);
}

SeRutQuiz.prototype.capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

SeRutQuiz.prototype.goToScreen = function(screen) {
    this.hideSource();

    // Replace variables in strings
    this.replaceVariablesInStrings();

    // Hide all screens
    Object.values(this.screens).forEach(screen => screen.classList.remove('active'));

    // Show the correct screen
    this.screens[screen].classList.add('active');

    // Start logics for the correct screen
    switch(screen) {
        case 'start' : this.hideBackArrow(); break;
        case 'questions' : this.startQuizScreen(); break;
        case 'singleResult' : this.initSingleResultScreen(); break;
    }

    this.activeScreen = screen;
    this.hadInteraction = true;
}

SeRutQuiz.prototype.showBackArrow = function() {
    this.backBtnEl.classList.add('visible');
}

SeRutQuiz.prototype.hideBackArrow = function() {
    this.backBtnEl.classList.remove('visible');
}

SeRutQuiz.prototype.startQuizScreen = function() {
    if (!this.screens.start.classList.contains('initialized')) {
        this.screens.start.classList.add('initialized');

        this.addBackBtnEventListener(() => {
            if (this.activeScreen === 'questions') {
                this.goToPrevQuestionView();
            }
        });
    }

    // Activate the first question
    this.questionEls.forEach(el => el.classList.remove('active'));
    this.questionEls[this.currentQuestionIndex].classList.add('active');

    this.screens.questions.addEventListener('change', e => {
        if (e.target.tagName.toLowerCase() === 'input') {
            // Check if the user has given an answer
            const checkedAnswerEl = this.questionEls[this.currentQuestionIndex].querySelector('input:checked');
            if (!checkedAnswerEl) return alert('Selecteer eerst een antwoord om door te gaan');

            // Save the answer
            this.urlData['a' + (this.currentQuestionIndex + 1)] = parseInt(checkedAnswerEl.value);

            // Send data to Analytics
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({ 'event': 'question_answered', 'quiz_id': this.quizId, 'question_name': '(' + this.quizId + ') ' + this.questions[this.currentQuestionIndex].analytics_title });
                dataLayer.push({ 'event': 'answer_given', 'quiz_id': this.quizId, 'question_name': '(' + this.quizId + ') ' + this.questions[this.currentQuestionIndex].analytics_title, 'answer_name': '(' + this.quizId + ') ' + this.questions[this.currentQuestionIndex].answers[checkedAnswerEl.value].associated_sentence });
            }

            // If the question had a video, pause it
            if (this.questions[this.currentQuestionIndex]['youtube_embed_url']) {
                const videoEl = this.questionEls[this.currentQuestionIndex].querySelector('.jsQuestionVideo iframe');
                videoEl.src = videoEl.src;
            }

            // Show the statistics screen
            this.showBackArrow();
            this.questionEls[this.currentQuestionIndex].classList.add('show-statistics');
            this.screens.questions.classList.add('show-statistics');

            // Add the source
            if (this.questions[this.currentQuestionIndex]['source_reference']) {
                this.setSource(this.questions[this.currentQuestionIndex]['source_reference']);
                this.showSource();
            }
            else {
                this.hideSource();
            }

            const bounds = this.parentSection.getBoundingClientRect();
            vanillaSmoothie.scrollTo(bounds.top + window.scrollY - this.getResponsiveTopOffset(), { easing: 'easeInOutQuad' });
        }
    });

    // Listen for events
    this.screens.questions.addEventListener('click', e => {
        if (e.target.classList.contains('jsNextQuestion')) {
            e.preventDefault();
            this.goToNextQuestion();
        }
    });
}

SeRutQuiz.prototype.getResponsiveTopOffset = function() {
    if (window.innerWidth < 1100) return 0;

    const headerEl = document.querySelector('.header');

    // Check if the header is fixed
    const headerStyle = window.getComputedStyle(headerEl);
    if (headerStyle.position !== 'fixed') return 0;

    return headerEl.offsetHeight;
};

SeRutQuiz.prototype.goToPrevQuestionView = function() {
    // If we're on the statistics screen, show the question
    if (this.screens.questions.classList.contains('show-statistics')) {
        this.questionEls[this.currentQuestionIndex].classList.remove('show-statistics');
        this.screens.questions.classList.remove('show-statistics');

        // Reset the radio buttons
        const radioBtnEls = this.screens.questions.querySelectorAll('.question[data-question-index="' + this.currentQuestionIndex + '"] input[type="radio"]');
        radioBtnEls.forEach(el => el.checked = false);
    }
    // If we're on the question screen, go to the previous question and show its statistics
    else {
        // Update the question index
        this.currentQuestionIndex--;
        if (this.currentQuestionIndex < 0) this.currentQuestionIndex = 0;

        // Go to the question
        this.goToQuestion(this.currentQuestionIndex);

        // Show the statistics
        this.questionEls[this.currentQuestionIndex].classList.add('show-statistics');
        this.screens.questions.classList.add('show-statistics');
    }

    // Hide the back arrow when we're at the first question (and not at it's statistics)
    if (this.currentQuestionIndex === 0 && !this.screens.questions.classList.contains('show-statistics')) {
        this.hideBackArrow();
    }
}

SeRutQuiz.prototype.goToNextQuestion = function() {
    this.hideSource();

    // Show the next question or go to the next screen
    const nextQuestionIndex = this.currentQuestionIndex + 1;

    if (nextQuestionIndex > (this.questionCount - 1)) {
        // Trigger the completed_personal_check action in GTM
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({ 'event': 'completed_personal_check', 'quiz_id': this.quizId, 'quiz_score': this.calculateCurrentUserScore() });
            dataLayer.push({ 'event': 'quiz_result_index', 'quiz_id': this.quizId, 'quiz_result_index': this.getSingleResultIndex() });
        }

        return this.goToScreen('singleResult');
    }
    else {
        this.currentQuestionIndex = nextQuestionIndex;
        this.goToQuestion(nextQuestionIndex);
    }
}

SeRutQuiz.prototype.goToQuestion = function(index) {
    this.showBackArrow();

    // Reset all questions to start with the question instead of the answer
    this.questionEls.forEach(el => el.classList.remove('show-statistics'));
    this.screens.questions.classList.remove('show-statistics');

    // Scroll to the top of the test
    const bounds = this.parentSection.getBoundingClientRect();
    vanillaSmoothie.scrollTo(bounds.top + window.scrollY - this.getResponsiveTopOffset(), { easing: 'easeInOutQuad' });

    // Show the question
    this.questionEls.forEach(el => el.classList.remove('active'));
    this.questionEls[index].classList.add('active');
}

SeRutQuiz.prototype.initActiveScreen = function() {
    // Hide all screens
    Object.values(this.screens).forEach(screen => screen.classList.remove('active'));

    // Check if all questions have already been answered, go to the single result screen
    if (this.urlData['a' + this.questionCount] !== null) return this.goToScreen('singleResult');

    return this.goToScreen('start');
}

SeRutQuiz.prototype.initStartScreen = function() {
    const nextBtnEl = this.screens.start.querySelector('.jsNext');

    nextBtnEl.addEventListener('click', e => {
        e.preventDefault();

        // Check if the name is given
        if (this.inputP1NameEl.value === '') {
            alert('Vul eerst je naam in om door te gaan.');
            return;
        }

        // Save the names to the data object
        this.urlData.name = this.capitalizeFirstLetter(this.inputP1NameEl.value);

        // Scroll to the section
        const bounds = this.parentSection.getBoundingClientRect();
        vanillaSmoothie.scrollTo(bounds.top + window.scrollY - this.getResponsiveTopOffset(), { easing: 'easeInOutQuad' })

        // Go to the questions screen
        this.goToScreen('questions');
    });
}

SeRutQuiz.prototype.initSingleResultScreen = function() {
    if (!this.screens.singleResult.classList.contains('initialized')) {
        const url = new Url;
        const btnWrapperEl = this.screens.singleResult.querySelector('.jsBtnWrapper');

        // If the URL contains shareMultiResult, hide the share button
        if (url.query.shareMultiResult) btnWrapperEl.classList.add('show-single-result');

        this.screens.singleResult.addEventListener('click', e => {
            if (e.target.classList.contains('jsFormTrigger')) {
                e.preventDefault();
                this.hideBackArrow();

                btnWrapperEl.classList.add('hide');
                this.screens.singleResult.querySelector('.jsFormWrapper').classList.add('show');
                this.screens.singleResult.querySelector('.jsSubtitle').innerHTML = 'Vertel ons hoe het was:';
            }
        });

        this.screens.singleResult.classList.add('initialized');
    }

    this.updateMultiResultsScreen();
}

SeRutQuiz.prototype.updateMultiResultsScreen = function() {
    // Check if all questions have been answered
    if (this.urlData['a' + (this.questionCount - 1)] === null) return;

    const topicListEl = this.screens.singleResult.querySelector('.jsTopicList');
    topicListEl.innerHTML = '';

    // Set the title
    const titleEl = this.screens.singleResult.querySelector('.jsTitle');
    titleEl.innerHTML = this.replaceVariablesInString(this.getSingleResultSentence());
}

SeRutQuiz.prototype.calculateCurrentUserScore = function() {
    let score = 0;

    for (let i = 0; i < this.questionCount; i++) {
        const answerIndex = this.urlData['a' + (i + 1)]
        if (typeof answerIndex !== 'undefined' && answerIndex !== null) score += parseInt(this.questions[i].answers[answerIndex].score);
    }

    return score;
}

SeRutQuiz.prototype.getSingleResultIndex = function() {
    const score = this.calculateCurrentUserScore();

    for (let i = 0; i < this.summarySentences.length; i++) {
        if (parseInt(this.summarySentences[i].score_start) <= score && parseInt(this.summarySentences[i].score_end) >= score) {
            return i + 1;
        }
    }

    return null;
}

SeRutQuiz.prototype.getSingleResultSentence = function() {
    const resultIndex = this.getSingleResultIndex();
    if (resultIndex === null) return null;

    return this.summarySentences[resultIndex - 1].sentence;
}

SeRutQuiz.prototype.replaceVariablesInString = function(string) {
    const findArray = [];
    const replaceArray = [];

    if (this.urlData['name'] !== null) {
        findArray.push('[naam-speler-1]');
        replaceArray.push(this.urlData['name']);
    }

    if (findArray.length === 0) return;

    return this.bulkStringReplace(string, findArray, replaceArray);
}

SeRutQuiz.prototype.replaceVariablesInStrings = function() {
    const findArray = [];
    const replaceArray = [];

    if (this.urlData['name'] !== null) {
        findArray.push('[naam-speler-1]');
        replaceArray.push(this.urlData['name']);
    }

    if (findArray.length === 0) return;

    this.replaceStringEls.forEach(el => {
        el.innerHTML = this.addSpansToString(this.bulkStringReplace(el.innerHTML, findArray, replaceArray), '##', ['text-color-green']);
    });
}

SeRutQuiz.prototype.bulkStringReplace = function(str, findArray, replaceArray) {
    let regex = [];
    const map = {};

    for (let i = 0; i < findArray.length; i++) {
        regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g,'\\$1'));
        map[findArray[i]] = replaceArray[i];
    }

    regex = regex.join('|');

    str = str.replace(new RegExp(regex, 'g'), function(matched) {
        return map[matched];
    });

    return str;
}

SeRutQuiz.prototype.addSpansToString = function(string, delimiter, classes) {
    let odd = true;
    const startSpan = classes ? '<span class="' + classes.join(' ') + '">' : '<span>';

    while (string.indexOf(delimiter) !== -1) {
        const pos = string.indexOf(delimiter);

        string = string.substring(0, pos) + (odd ? startSpan : '</span>') + string.substring(pos + delimiter.length, string.length);
        odd = !odd;
    }

    return string;
}

SeRutQuiz.prototype.setSource = function(source) {
    this.sourceEl.innerHTML = source;
}

SeRutQuiz.prototype.hideSource = function() {
    this.sourceEl.classList.remove('show');
}

SeRutQuiz.prototype.showSource = function() {
    this.sourceEl.classList.add('show');
}


document.addEventListener('DOMContentLoaded', function() {
    const quizEls = document.querySelectorAll('.jsRuqQuiz');
    quizEls.forEach(el => new SeRutQuiz(el));
});
